import { render, staticRenderFns } from "./humptext.vue?vue&type=template&id=16cdfc31&"
import script from "./humptext.vue?vue&type=script&lang=js&"
export * from "./humptext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports